import React, { Component } from 'react'
import { Input, InputNumber } from 'antd';

// Click a value to edit it in place, blur/Enter to save. Used throughout the
// Supply list and form so common fields (name, price, quantity, position...)
// don't require opening a separate edit screen.
class InlineEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            value: props.value,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && !this.state.editing) {
            this.setState({ value: this.props.value });
        }
    }

    startEdit = () => {
        this.setState({ editing: true, value: this.props.value });
    }

    commit = () => {
        this.setState({ editing: false });
        if (this.state.value !== this.props.value) {
            this.props.onSave(this.state.value);
        }
    }

    render() {
        let { editing, value } = this.state;
        let { type, placeholder, prefix, suffix, min } = this.props;

        if (!editing) {
            let display = (value !== null && value !== undefined && value !== '')
                ? <span>{prefix}{value}{suffix}</span>
                : <em className="inline-edit-placeholder">{placeholder || '—'}</em>;
            return (
                <span className="inline-edit-display" onClick={this.startEdit}>
                    {display}
                </span>
            );
        }

        if (type === 'number') {
            return (
                <InputNumber
                    autoFocus
                    size="small"
                    min={min}
                    value={value}
                    onChange={(v) => this.setState({ value: v })}
                    onBlur={this.commit}
                    onPressEnter={this.commit}
                />
            );
        }

        return (
            <Input
                autoFocus
                size="small"
                value={value}
                onChange={(e) => this.setState({ value: e.target.value })}
                onBlur={this.commit}
                onPressEnter={this.commit}
            />
        );
    }
}

export default InlineEdit;
